module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgOCA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNC41IiByPSI0IiBmaWxsPSIjMkE3MUQ0Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dot.svg
// module id = iFWK
// module chunks = 1